import React from 'react';
import { CTASection } from '../../../components/CTASection';
export function CTA() {
  return <section className="py-16 bg-white" data-id="element-551">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-552">
        <CTASection headline="Ready to Build Your Mobile App?" body="Let's discuss your mobile application requirements and how we can bring your vision to life." buttonText="Start the Conversation" buttonLink="/contact" variant="dark" data-id="element-553" />
      </div>
    </section>;
}